import clsx from 'clsx'
import CodeViewer from 'components/CodeViewer/CodeViewer'
import { formatJSON } from 'helpers/format'
import { EthernetPortIcon } from 'lucide-react'
import { IPBlockList } from 'models/event'

import { IdentificationUrlKeys } from '../../../types'
import { SmartSignalDefinition } from './SmartSignalRepresentation'

export const ipBlocklistDefinition: SmartSignalDefinition<{ ip_blocklist?: IPBlockList }> = {
  key: 'ip-blocklist',
  label: 'IP blocklist',
  extract: (e) => ({ ip_blocklist: e.ip_blocklist }),
  icon(e) {
    const p = this.extract(e)?.ip_blocklist
    const detected = p && Object.values(p).some((v) => v === true)
    return (
      <EthernetPortIcon
        className={clsx('size-4', {
          'text-red-800': detected,
        })}
      />
    )
  },
  details(e) {
    return (
      <CodeViewer
        value={formatJSON(this.extract(e))}
        withSearch={false}
        className={this.isDetected(e) ? 'bg-red-100 border-red-300' : 'bg-gray-100'}
      />
    )
  },
  isDetected(e) {
    const p = this.extract(e)?.ip_blocklist
    return p != null && Object.values(p).some((v) => v === true)
  },
  isWeb: () => true,
  isMobile: () => true,
  searchFor: '"ip_blocklist":',
  documentationHash: '#ip-blocklist-matching',
  urlParamKey: IdentificationUrlKeys.IpBlocklist,
}
